import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "../index.css";
import "./SlackAppInfo.css";

import toast from "react-hot-toast";

export default function SlackAppInfo() {
  const navigate = useNavigate();
  return (
    <div id="slack-app-info-page">
      <div className="slack-app-info-page-body">
        <img
          className="slack-app-info-winslow-icon"
          src="/logos/winslow_logo.svg"
          alt=""
          onClick={() => navigate("/")}
        />
        <div className="slack-app-info-page-text">
          <div className="row">
            <div className="slack-app-info-file-name">
              All about our slack app!
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
